import { HttpErrCode } from 'zf-web-infra';
import { Exception } from './exception';
import type { ReactElement } from 'react';

export function NotFound(): ReactElement {
  return (
    <Exception error={{
      type: 'show',
      kind: 'onerror',
      timestamp: Date.now(),
      code: HttpErrCode.NOT_FOUND,
      message: 'Not Found',
      error: undefined
    }} />
  );
}
